import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';

// Our Axios Instance
import axiosInstance from 'services/API/API';

// Api URLS
import { getUserLiabilitiesUrl } from 'shared/api-urls';

// QUery keys
import { USER_MORTGAGES } from 'shared/query-keys';

// our routes
import { LIABILITY_ADDITIONAL_ROUTE } from 'routes';

// Our utils
import getNonNullValues from 'shared/utils/clientOnboarding/getNonNullValues';

function useGetUserMortgageLiability() {
	const location = useLocation();
	const { pathname } = location;
	const { tradeLineId } = useParams();

	const isManualRoute = pathname.includes(LIABILITY_ADDITIONAL_ROUTE);

	// if this is a isManualRoute do not do the data binding

	const urlWithTradeLineId = `${getUserLiabilitiesUrl}${tradeLineId}`;

	return useQuery(
		[USER_MORTGAGES, tradeLineId],
		async () => {
			const response = await axiosInstance.get(urlWithTradeLineId);

			// This is the data from Sora Api which includes meta
			const Liability = response.data;

			// This is the actual mortgage Data
			const mortgageData = Liability.data;

			return mortgageData;
		},
		{
			enabled: !isManualRoute,
			refetchOnWindowFocus: false,
			select: ({
				clientHome,
				expectedPayOffDate,
				escrow,
				dataSource,
				financialGoal,
				interestRate,
				lender,
				loanType,
				monthlyPay,
				monthlyMortgagePayment,
				outstandingBalance,
				propertyOwnershipTenure,
				rateManuallyUpdated,
				tenureMonth
			}) => {
				// get rid of garbage data before giving it to HomeLiability Component
				const mortgageDataWithoutNullValues = getNonNullValues({
					clientHome,
					expectedPayOffDate,
					escrow,
					dataSource,
					financialGoal,
					interestRate,
					lender,
					loanType,
					monthlyPay,
					monthlyMortgagePayment,
					outstandingBalance,
					propertyOwnershipTenure,
					rateManuallyUpdated,
					tenureMonth
				});

				return mortgageDataWithoutNullValues;
			}
		}
	);
}

export default useGetUserMortgageLiability;
